import { Button } from "~/common/components/Button/Button";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";

interface Props {
  resultAmount: number;
  className?: string;
}
export const ShowProductsBtn = ({ resultAmount, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Button size={"medium"} href={"#results"} className={className}>
      <Icon type={IconType.ArrowDown} className="icon-margin" data-test-id={"selectionassistant-showallproducts"} />
      <span>
        {t("page.selectionAssistant.showNumberOfProducts", {
          count: resultAmount,
        })}
      </span>
    </Button>
  );
};
